import React from 'react'
import injectStyles from 'react-jss'
import { Tooltip } from '@material-ui/core'
import { NoData } from '../../Assets/Images/icons/noData'
import { styles } from './styles'

const TooltipModal = ({ content, iconFill, classes, placement = 'top' }) => {
  return (
    <Tooltip
      title={content}
      placement={placement}
      classes={{
        tooltip: classes.tooltip,
        popper: classes.popper,
      }}
    >
      <div className={classes.iconWrapper}>
        <NoData fill={iconFill} />
      </div>
    </Tooltip>
  )
}

export default injectStyles(styles)(TooltipModal)
